export default {
  props: {
    d: String
  },
  render(){
    return this.d
    ? (<span>{this.d}</span>)
    : (<span class="no-data">无数据</span>)
  }
}


// WEBPACK FOOTER //
// ./src/components/TableCell/NoData.js